var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContenedorCampos',{attrs:{"titulo":'',"isObligatorio":'false'}},[_c('div',{staticClass:"container my-5 class_info"},[_c('span',{attrs:{"my-10":""}},[_vm._v(_vm._s(_vm.titulo))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }